<template>
  <div class="content animate-panel" id="content">
    <div style="display: flex; align-items: center; gap: 20px">
      <nav-tabs :tab="tab"></nav-tabs>
    </div>
    <div v-if="isReady"  class="hpanel">
      <tab-content :tab="tab" :banners="banners"></tab-content>
    </div>
  </div>
</template>
<script>
import NavTabs from './NavTabs'
import TabContent from './TabContent'
import ProductService from '@/services/productservice'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      isReady: false,
      tab: null,
      loader: null,
      banners: {
        productListBanner: '',
        productAddBanner: ''
      }
    }
  },
  watch: {
    $route (to, from) {
      const fromTab = from.params.tab
      const toTab = to.params.tab
      if (fromTab !== toTab && ['list', 'add-by-amazon', 'reports'].includes(toTab)) {
        this.tab = toTab
      } else {
        this.$router.push('/not-found')
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.tab = this.$route.params.tab
      if (!['list', 'add-by-amazon', 'reports'].includes(this.tab)) {
        this.$router.push('not-found')
        return
      }

      this.loader = this.$loading.show()
      await this.getLatestProducts()
      this.getBanners()
    },
    async getBanners () {
      await ProductService.getBanners()
        .then(response => {
          if (response.data) {
            this.banners = response.data
          }
        })
    },
    async getLatestProducts () {
      await ProductService.getLatestProducts({ checkLatestDate: true })
        .then((response) => {
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.isReady = true
          this.loader && this.loader.hide()
        })
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/Products.vue